const expressHostname = process.env.REACT_APP_EXPRESS_HOSTNAME || 'http://localhost';
const expressPort = process.env.REACT_APP_EXPRESS_PORT;

// Only add the colon if a port actually exists
const expressURL = expressPort ? `${expressHostname}:${expressPort}` : expressHostname;
 
const fastApiHostname = process.env.REACT_APP_FASTAPI_HOSTNAME || 'http://localhost';
const fastApiPort = process.env.REACT_APP_FASTAPI_PORT;

const fastApiURL = fastApiPort ? `${fastApiHostname}:${fastApiPort}` : fastApiHostname;

const wizardHostname = process.env.REACT_APP_WIZARD_HOSTNAME || 'http://localhost';
const wizardPort = process.env.REACT_APP_WIZARD_PORT;
const wizardURL = wizardPort ? `${wizardHostname}:${wizardPort}` : wizardHostname;

const baseURL = expressURL; 

export { expressURL, fastApiURL, wizardURL, baseURL };
export default baseURL;